export enum PaymentFeeType {
    None = 'none',
    Fixed = 'fixed',
    Percent = 'percent',
}